/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareDto } from './shareDto';
import { DeploymentDto } from './deploymentDto';


export interface CollarDashboardDto { 
    id: number;
    label?: string;
    shares: Array<ShareDto>;
    name: string;
    color?: string;
    deployments?: Array<DeploymentDto>;
    lastReception?: string;
    lastPosMainV?: number;
    lastPosAcqTime?: string;
    lastPosMortStatus?: CollarDashboardDto.LastPosMortStatusEnum;
    comType?: CollarDashboardDto.ComTypeEnum;
    deviceType?: string;
    networkStatus?: CollarDashboardDto.NetworkStatusEnum;
}
export namespace CollarDashboardDto {
    export const LastPosMortStatusEnum = {
        NotAvailable: 'NOT_AVAILABLE',
        NothingDetected: 'NOTHING_DETECTED',
        LowActivityNoRadius: 'LOW_ACTIVITY_NO_RADIUS',
        LowActivityInsideRadius: 'LOW_ACTIVITY_INSIDE_RADIUS',
        LowActivityOutsideRadius: 'LOW_ACTIVITY_OUTSIDE_RADIUS',
        MortalityNoRadius: 'MORTALITY_NO_RADIUS',
        MortalityInsideRadius: 'MORTALITY_INSIDE_RADIUS',
        MortalityOutsideRadius: 'MORTALITY_OUTSIDE_RADIUS'
    } as const;
    export type LastPosMortStatusEnum = typeof LastPosMortStatusEnum[keyof typeof LastPosMortStatusEnum];
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const NetworkStatusEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type NetworkStatusEnum = typeof NetworkStatusEnum[keyof typeof NetworkStatusEnum];
}


